import BaseService from '../core/service/BaseService';

const url = 'solicitacao-ativacao-indicador';
class SolicitacaoAtivacaoIndicadorService extends BaseService {
    async salvar({ ativar, idIndicador, justificativa, tipos }) {
        const tipo = tipos.find((el) =>
            ativar
                ? el?.codgTipoSolicitacaoAtivacao === 'ATIVAR_INDICADOR'
                : el?.codgTipoSolicitacaoAtivacao === 'INATIVAR_INDICADOR'
        );

        const response = await window.$http.post(
            `${url}`,
            {
                indicador: { id: idIndicador },
                tipoSolicitacaoAtivacao: tipo,
                descJustificativa: justificativa,
            },
            { ignoreReject: true }
        );
        return response;
    }

    async analisar(idSolicitacao, { manifestacao, flagValidacao }) {
        const response = await window.$http.post(`${url}/analisar/${idSolicitacao}`, {
            descManifestacaoTecnica: manifestacao,
            analise: flagValidacao ? 'VALIDAR' : 'DESCARTAR',
        });
        return response;
    }
}

export default new SolicitacaoAtivacaoIndicadorService(url);
